import React from 'react';

const CallToAction = () => {
  return (
    <div className="fn_cs_call_to_action">
      <style>{`
        @media (max-width: 768px) {
          .fn_cs_call_to_action .link_holder {
            margin-bottom: 15px;
          }
          .fn_cs_call_to_action .link_holder:last-child {
            margin-bottom: 0;
          }
        }
      `}</style>
      <div className="container">
        <div className="cta_holder">
          <div className="title_holder">
            <h3>Message from the Leadership</h3>
            <p>Shaping the Future with Experience and Commitment</p>
          </div>
          <div className="link_holder">
            <a 
              href="/about-aid" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              About AID
            </a>
          </div>
          <div className="link_holder">
            <a 
              href="/members" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Excutive Committee
            </a>
          </div>
          <div className="link_holder">
            <a 
              href="/vision-mission" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Vision & Mission
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;